/**
 * SeriesPill — "Series · 3 of 12" beside the lifecycle pill on a workshop that
 * was generated from a recurring series. The cadence sits in the
 * tooltip. Provenance only: the workshop is edited on its own.
 */
import type { WorkshopSeriesSummary } from '../../../../api/workshops';

export function SeriesPill({ series }: { series: WorkshopSeriesSummary }) {
  return (
    <span
      className="nb-pill"
      title={series.label}
      aria-label={`Part of a series: ${series.position} of ${series.total}, ${series.label}`}
      style={{
        height: 20,
        fontSize: 10.5,
        padding: '0 9px',
        background: 'var(--nb-surface-2)',
        color: 'var(--nb-muted)',
        borderColor: 'transparent',
      }}
    >
      Series · {series.position} of {series.total}
    </span>
  );
}
